export default __webpack_public_path__ + "static/media/ZoneConfigImage.3e01edf1.jpg";